import React, { useContext } from "react";
import { AccountContext } from "../account/AccountContext";
import { useShortcut } from "../utils/utils";

export function Title({detailRef}:{detailRef:React.MutableRefObject<HTMLDivElement>}){
    const {dispatch, tableMode, account, googleMode, customGoalMode} = useContext(AccountContext);

    function onClick(){
        if(!account && tableMode) dispatch({type: "setTableMode", payload: false});
        dispatch({type: "selectAccount", payload: null});
        setTimeout(() => {
            if(!detailRef) return;
            detailRef.current.classList.remove("disappear")
            detailRef.current.classList.add("appear")
        }, 1);
    }

    function goTableMode(){
        if(!tableMode) {
            dispatch({type: "setTableMode", payload: true});
            dispatch({type: "setChannelMode", payload: false});
        }
    }

    function goChannelMode(){
        dispatch({type: "setChannelMode", payload: true});
    }


    useShortcut("KeyH", onClick);
    useShortcut("KeyT", goTableMode);
    useShortcut("KeyC", goChannelMode);

    const icon = customGoalMode ?  'icon-2' : 'icon-1';

    return <h3 onClick={onClick}>
        <img className="me-2" src={`https://dash.proglingo.com/notifications/${ googleMode ? 'google-icon' : icon}.png`} width="40" height="40" />
        {googleMode ? 'Google Ads Report' : 'Meta Ads Report'}
    </h3>
}